//removeIf(production)
import ClaroluzEventDispatch from "./../../../../../infra/services/claroluz-event-dispatch";
import ClaroluzEvents from "./../../../../../infra/critical/claroluz-events";
//endRemoveIf(production)

class ClaroluzReset {
    constructor() {
        this.resetAllClick();
        this.resetAllEvent();
    }

    private resetQrCode() {
        let qrCode = document.querySelector('.claroluz-qr') as HTMLElement;
        if (qrCode.classList.contains('scan')) {
            qrCode.classList.remove('scan');

            new ClaroluzEventDispatch('claroluz_reset');
            new ClaroluzEvents(appProperties(), 'uploader', 'qr-code', 'reset');
        }        
    }

    private resetDropzone() {
        let dropzone = document.querySelector('.claroluz-uploader-pdf') as HTMLElement;
        if (dropzone.classList.contains('dz-started')) {
            dropzone.querySelectorAll('.dz-preview').forEach((file) => {
                let element = file.querySelector('.dz-remove') as HTMLElement;
                element.click();
            });

            new ClaroluzEvents(appProperties(), 'uploader', 'dropzone', 'reset');
        }
    }

    private resetCups() {
        let reset = false;

        document.querySelectorAll('.claroluz-cups .cups-input').forEach((element) => {
            let input = element as HTMLInputElement;

            if (input.value !== '') {
                input.value = '';
                reset = true;
            }
        });

        if (reset) {
            new ClaroluzEvents(appProperties(), 'uploader', 'cups', 'reset');
        }
    }

    private uncheckPrivacy() {
        let privacy = document.querySelector('.claroluz-uploader-checkbox .claroluz-checkbox--checkbox') as HTMLInputElement;
        privacy.checked = false;
    }

    private resetAll() {
        this.resetQrCode();
        this.resetDropzone();
        this.resetCups();
        this.uncheckPrivacy();

        if (document.querySelector('.claroluz-comparator')!.classList.contains('show')) {
            new ClaroluzEvents(appProperties(), 'comparator', 'close', 'click');
            document.querySelector('.claroluz-comparator')!.classList.remove('show');        
            document.querySelector('.claroluz-comparator')!.classList.remove('contract');        
            document.querySelector('.claroluz-offers-cards-container')!.innerHTML = '';   
        }
    }

    private resetAllClick() {
        document.querySelectorAll('.claroluz-reset-all').forEach((element) => {
            element.addEventListener('click', () => {
                this.resetAll();
            });
        });
    }

    private resetAllEvent() {
        document.addEventListener('claroluz_reset', () => {
            this.resetAll();
        });
    }
}

//removeIf(production)
export default ClaroluzReset;
function appProperties(): import("../../../../../infra/critical/claroluz-events-properties").default {
    throw new Error("Function not implemented.");
}
//endRemoveIf(production)